import actionCreatorFactory from 'typescript-fsa';

import * as api from '../api';
import * as store from './store';

const actionCreator = actionCreatorFactory();

export const setEhrProviderInformationList = actionCreator<
  api.User.EhrProviderInformationPractice[] | null
>('SET_EHR_PROVIDER_INFORMATION_LIST');
export function setEhrProviderInformationListHandler(
  state: store.All,
  ehrProviderInformation: api.User.EhrProviderInformationPractice[] | null,
): store.All {
  return {
    ...state,
    inbound: { ...state.inbound, ehrProviderInformation },
  };
}

export const setSelectedEhrTimeSlot =
  actionCreator<store.SelectedEhrTimeSlot | null>('SET_SELECTED_EHR_TIME_SLOT');
export function setSelectedEhrTimeSlotHandler(
  state: store.All,
  selectedEhrTimeSlot: store.SelectedEhrTimeSlot | null,
): store.All {
  return {
    ...state,
    inbound: { ...state.inbound, selectedEhrTimeSlot },
  };
}

export const setBookedSlot =
  actionCreator<api.EhrTimeSlot.TimeSlotConfirmation | null>('SET_BOOKED_SLOT');
export function setBookedSlotHandler(
  state: store.All,
  bookedSlot: api.EhrTimeSlot.TimeSlotConfirmation | null,
): store.All {
  return {
    ...state,
    inbound: { ...state.inbound, bookedSlot },
  };
}

// Stored from query params
export const setSelectedProviderId = actionCreator<{
  selectedProviderId: string | null;
}>('SET_SELECTED_PROVIDER_ID');
export function setSelectedProviderIdHandler(
  state: store.All,
  values: {
    selectedProviderId: string | null;
  },
): store.All {
  const { selectedProviderId } = values;
  return {
    ...state,
    inbound: { ...state.inbound, selectedProviderId },
  };
}

export const setProvisionalPatientId = actionCreator<string | null>(
  'SET_PROVISIONAL_PATIENT_ID',
);
export function setProvisionalPatientIdHandler(
  state: store.All,
  provisionalPatientId: string | null,
): store.All {
  return {
    ...state,
    inbound: { ...state.inbound, provisionalPatientId },
  };
}

export const setUrlIdentifier = actionCreator<string | null>(
  'SET_URL_IDENTIFIER',
);
export function setUrlIdentifierHandler(
  state: store.All,
  urlIdentifier: string | null,
): store.All {
  return {
    ...state,
    inbound: { ...state.inbound, urlIdentifier },
  };
}

export const setOrganizationId = actionCreator<string>('SET_ORGANIZATION_ID');
export function setOrganizationIdHandler(
  state: store.All,
  organizationId: string,
): store.All {
  return {
    ...state,
    inbound: { ...state.inbound, organizationId },
  };
}

export const setOrganizationSlug = actionCreator<string | null>(
  'SET_ORGANIZATION_SLUG',
);
export function setOrganizationSlugHandler(
  state: store.All,
  organizationSlug: string | null,
): store.All {
  return {
    ...state,
    inbound: { ...state.inbound, organizationSlug },
  };
}

export const setIsProvisionalPatientReconciled = actionCreator<boolean>(
  'SET_IS_PROVISIONAL_PATIENT_RECONCILED',
);
export function setIsProvisionalPatientReconciledHandler(
  state: store.All,
  isProvisionalPatientReconciled: boolean,
): store.All {
  return {
    ...state,
    inbound: { ...state.inbound, isProvisionalPatientReconciled },
  };
}
